import { render, staticRenderFns } from "./VatComponent.vue?vue&type=template&id=00049c2e&"
import script from "./VatComponent.vue?vue&type=script&lang=js&"
export * from "./VatComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/pp-weberbuero-50965/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00049c2e')) {
      api.createRecord('00049c2e', component.options)
    } else {
      api.reload('00049c2e', component.options)
    }
    module.hot.accept("./VatComponent.vue?vue&type=template&id=00049c2e&", function () {
      api.rerender('00049c2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/VatComponent.vue"
export default component.exports